import { Component, Input } from "@angular/core";

import { BaseSearchTabConfigModel } from "../../../../models/base-search-tab-config.model";
import { SearchResultsModel } from "../../models/search-results.model";

@Component({
    selector: "pcg-ng-directory-search-results-list",
    template: require('./directory-search-results-list.component.html')
})
export class DirectorySearchResultsListComponent {
    @Input()
    public searchConfig: BaseSearchTabConfigModel;

    @Input()
    public searchResult: SearchResultsModel;
}
